import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationEmployeeScanIn from 'graphql/mutations/MutationEmployeeScanIn'
import _ from 'lodash'
import MutationEmployeeScanOut from 'graphql/mutations/MutationEmployeeScanOut'
import { scanThroughConstants } from 'utils/constants/scan-constants'
import { MODE_SCAN_IN, MODE_SCAN_OUT } from 'utils/constants/qrcode-constants'

export default class MutateScan {
	/**
	 *
	 * @param code
	 * @param employeeGuid
	 * @param scannedInThrough
	 * @param callbackSuccess
	 * @param callbackError
	 * @param callbackStart
	 */
	static scanIn = ( code, { employeeGuid = '::employee_guid', scannedInThrough = scanThroughConstants.QRCODE, timeslotGuid = null, callbackSuccess = null, callbackError = null, callbackStart = null } ) => {
		let graphQlBuilder = new GraphqlBuilder();
		
		// Create the scan in
		graphQlBuilder.addQuery( 'scan', MutationEmployeeScanIn, {
			employee_guid: employeeGuid,
			code: code,
			scanned_in_through: scannedInThrough,
			timeslot_guid: timeslotGuid
		});
		
		this.callGraphqlBuilder( graphQlBuilder, {
			callbackStart: callbackStart,
			callbackSuccess: callbackSuccess,
			callbackError: callbackError,
			scanMode: MODE_SCAN_IN
		} );
	}
	
	/**
	 *
	 * @param code
	 * @param employeeGuid
	 * @param scannedOutThrough
	 * @param callbackSuccess
	 * @param callbackError
	 * @param callbackStart
	 */
	static scanOut = ( code, { employeeGuid = '::employee_guid', scannedOutThrough = scanThroughConstants.QRCODE, callbackSuccess = null, callbackError = null, callbackStart = null } ) => {
		let graphQlBuilder = new GraphqlBuilder();
		
		// Create the scan in
		graphQlBuilder.addQuery( 'scan', MutationEmployeeScanOut, {
			employee_guid: employeeGuid,
			code: code,
			scanned_out_through: scannedOutThrough
		});
		
		this.callGraphqlBuilder( graphQlBuilder, {
			callbackStart: callbackStart,
			callbackSuccess: callbackSuccess,
			callbackError: callbackError,
			scanMode: MODE_SCAN_OUT
		} );
	}
	
	/**
	 *
	 * @param graphQlBuilder
	 * @param callbackSuccess
	 * @param callbackError
	 * @param callbackStart
	 * @param scanMode
	 * @returns {*}
	 */
	static callGraphqlBuilder = ( graphQlBuilder, { scanMode = MODE_SCAN_IN, callbackSuccess = null, callbackError = null, callbackStart = null } ) => {
		graphQlBuilder.setOnStart( callbackStart )
		
		graphQlBuilder.setOnSuccess( result => {
			this.onSuccess( result, {
				callbackSuccess: callbackSuccess,
				callbackError: callbackError,
				scanMode: scanMode
			});
		});
		
		graphQlBuilder.setOnError( (result, {error}) => {
			this.onError( result, {
				callbackError: callbackError
			});
		});
		
		graphQlBuilder.execute();
	}
	
	/**
	 *
	 * @param result
	 * @param callbackSuccess
	 * @param callbackError
	 * @param scanMode
	 */
	static onSuccess = ( result, { scanMode = MODE_SCAN_IN, callbackSuccess = null, callbackError = null } = {} ) => {
		const employeeScan = _.get( result, [ 'scan', ( scanMode === MODE_SCAN_IN ? 'employee_scan_in_with_code' : 'employee_scan_out_with_code' ) ], {} );
		const employeeScanGuid = _.get( employeeScan, 'guid', null );
		
		// Is it null? Then it failed.. :(
		if( employeeScanGuid === null ) {
			this.onError( result, {
				callbackError: callbackError
			} );
			
			return;
		}
		
		if( _.isFunction( callbackSuccess ) ) {
			callbackSuccess( employeeScan );
		}
	}
	
	/**
	 *
	 * @param result
	 * @param callbackError
	 */
	static onError = ( result, { callbackError = null } = {} ) => {
		if( _.isFunction( callbackError ) ) {
			callbackError();
		}
	}
}
